import { FilterXSS, escapeAttrValue } from 'xss'

export const filter = new FilterXSS({
  onIgnoreTagAttr(_, name, value) {
    if (name === 'class') {
      return `${name}="${escapeAttrValue(value)}"`
    }

    return undefined
  },
})

export const sanitize = filter.process.bind(filter)
